import { render, staticRenderFns } from "./ChallengeDialogAccept.vue?vue&type=template&id=84d05a2a"
import script from "./ChallengeDialogAccept.vue?vue&type=script&lang=ts"
export * from "./ChallengeDialogAccept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports